var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatePicker = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "eehtfqatga"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.749020 0 0 0 0 0.749020 0 0 0 0 0.749020 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#eehtfqatga)",
  transform: "translate(-40 -283) translate(20 245)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(20 38)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#C5C5C5",
  strokeDasharray: "5 4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
  transform: "translate(20 38)"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#C5C5C5",
  strokeWidth: 1.2,
  d: "M9.871.52v.52c0 .286-.233.519-.52.519H5.196",
  transform: "translate(20 38) translate(5 5) translate(.328 .328)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C5C5C5",
  strokeWidth: 1.2,
  d: "M12.988 2.078v8.832c0 .86-.697 1.559-1.558 1.559H2.078c-.86 0-1.558-.698-1.558-1.559V3.117c0-.86.697-1.558 1.558-1.558.287 0 .52-.233.52-.52V.52",
  transform: "translate(20 38) translate(5 5) translate(.328 .328)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5C5C5",
  fillRule: "nonzero",
  d: "M3.396 5.756c.892 0 .893-1.386 0-1.386-.891 0-.893 1.386 0 1.386M5.708 5.756c.891 0 .893-1.386 0-1.386-.892 0-.893 1.386 0 1.386M8.02 5.756c.89 0 .892-1.386 0-1.386s-.894 1.386 0 1.386M10.33 5.756c.892 0 .893-1.386 0-1.386-.891 0-.892 1.386 0 1.386M3.396 7.95c.892 0 .893-1.385 0-1.385-.891 0-.893 1.385 0 1.385M5.708 7.95c.891 0 .893-1.385 0-1.385-.892 0-.893 1.385 0 1.385M8.02 7.95c.89 0 .892-1.385 0-1.385s-.894 1.385 0 1.385M10.33 7.95c.892 0 .893-1.385 0-1.385-.891 0-.892 1.385 0 1.385M3.396 10.145c.892 0 .893-1.386 0-1.386-.891 0-.893 1.386 0 1.386M5.708 10.145c.891 0 .893-1.386 0-1.386-.892 0-.893 1.386 0 1.386M8.02 10.145c.89 0 .892-1.386 0-1.386s-.894 1.386 0 1.386",
  transform: "translate(20 38) translate(5 5) translate(.328 .328)"
}))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatePicker);
export default ForwardRef;